import { useQuery } from "react-query";

import { getOrgUserList } from "api/users";

import { UserOption } from "components/project/projects/components/ProjectInput";

export const ORG_USERS_QUERY_KEYS = {
  orgUsers: "orgUsers"
};

interface UserData {
  id: string;
  firstName?: string;
  lastName?: string;
}

const transformUsersToOptions = (usersData: UserData[]): UserOption[] => {
  return usersData.reduce((items, u) => {
    if (u.firstName || u.lastName) {
      items.push({
        label: `${u.firstName} ${u.lastName}`,
        value: u.id
      });
    }
    return items;
  }, []);
};

export default function useOrgUsersQuery() {
  const queryInfo = useQuery({
    queryKey: [ORG_USERS_QUERY_KEYS.orgUsers],
    queryFn: getOrgUserList,
    staleTime: 10 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1,
    select: (response) => {
      if (response && response.data) {
        const options = transformUsersToOptions(response.data);
        return options.sort((a, b) => a.label.localeCompare(b.label));
      }
      return [];
    }
  });

  return {
    ...queryInfo,
    userOptions: queryInfo.data || []
  };
}
